export default {
  refferalToken: null,
};
